import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import "./Navbar.scss";
import logo from "../../assets/BTPL_Logo.jpg";

import { Link as RouterLink } from "react-router-dom";

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Lock body scroll when menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add("nav-open");
    } else {
      document.body.classList.remove("nav-open");
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove("nav-open");
    };
  }, [isMobileMenuOpen]);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => setIsMobileMenuOpen((s) => !s);
  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  // Handle navigation with smooth closing
  const handleNavigation = (sectionId) => {
    if (isMobileMenuOpen) {
      // Add delay for smooth closing animation
      setTimeout(() => {
        closeMobileMenu();
      }, 100);
    }
  };

  // Create navbar classes
  const navbarClasses = [
    "navbar",
    isScrolled && "navbar--scrolled",
    isMobileMenuOpen && "navbar--overlay",
  ]
    .filter(Boolean)
    .join(" ");

  const navLinksClasses = [
    "nav-links",
    isMobileMenuOpen && "nav-links--overlay",
    isMobileMenuOpen && "nav-links--open",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <>
      {/* Overlay background */}
      <div
        className={`overlay-bg ${isMobileMenuOpen ? "overlay-bg--open" : ""}`}
      />

      <header className={navbarClasses}>
        <div className="navbar__left">
          <img src={logo} alt="Belageri Technologies" className="logo" />
          <span className="navbar__title">Belageri Technologies</span>
        </div>

        <div className="navbar__right">
          <nav className={navLinksClasses}>
            <Link
              to="hero"
              smooth={true}
              duration={500}
              offset={-70}
              className="nav-link"
              onClick={() => handleNavigation("hero")}
              spy={true}
              activeClass="active"
            >
              Home
            </Link>

            <Link
              to="about"
              smooth={true}
              duration={500}
              offset={-70}
              className="nav-link"
              onClick={() => handleNavigation("about")}
              spy={true}
              activeClass="active"
            >
              About Us
            </Link>

            <Link
              to="workwithus"
              smooth={true}
              duration={500}
              offset={-70}
              className="nav-link"
              onClick={() => handleNavigation("workwithus")}
              spy={true}
              activeClass="active"
            >
              Work With Us
            </Link>

            <Link
              to="products"
              smooth={true}
              duration={500}
              offset={-70}
              className="nav-link"
              onClick={() => handleNavigation("products")}
              spy={true}
              activeClass="active"
            >
              Products
            </Link>

            <RouterLink
              to="/careers"
              className="nav-link"
              onClick={closeMobileMenu}
            >
              Careers
            </RouterLink>

            <Link
              to="services"
              smooth={true}
              duration={500}
              offset={-70}
              className="nav-link"
              onClick={() => handleNavigation("services")}
              spy={true}
              activeClass="active"
            >
              Services
            </Link>

            <Link
              to="testimonials"
              smooth={true}
              duration={500}
              offset={-70}
              className="nav-link"
              onClick={() => handleNavigation("testimonials")}
              spy={true}
              activeClass="active"
            >
              Testimonials
            </Link>

            <Link
              to="contact"
              smooth={true}
              duration={500}
              offset={-70}
              className="nav-link"
              onClick={() => handleNavigation("contact")}
              spy={true}
              activeClass="active"
            >
              Contact Us
            </Link>
          </nav>

          <button
            className={`hamburger ${isMobileMenuOpen ? "hamburger--open" : ""}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            <span className="hamburger__line"></span>
            <span className="hamburger__line"></span>
            <span className="hamburger__line"></span>
          </button>
        </div>
      </header>
    </>
  );
}

export default Navbar;
